<ul>
  <li>
    <a routerLink="">
      <i class="pi pi-home"></i>
    </a>
  </li>
  @for (item of items; track item.routerLink + item.url) {
    <li>
      @if (item.routerLink) {
        <a [routerLink]="item.routerLink">{{item.label}}</a>
      }
      @if (!item.routerLink) {
        {{item.label}}
      }
    </li>
  }
</ul>
